import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { deleteAction, postAction, getAction } from '@/api/manage';
import SelectUserModal from "./modules/SelectUserModal";
import RoleModal from "./modules/RoleModal";
import UserModal from "./modules/UserModal";
import { filterObj } from '@/utils/util';
export default {
  name: 'RoleUserList',
  mixins: [JeecgListMixin],
  components: {
    SelectUserModal: SelectUserModal,
    RoleModal: RoleModal,
    UserModal: UserModal
  },
  data: function data() {
    return {
      model1: {},
      model2: {},
      currentRoleId: '',
      queryParam1: {},
      queryParam2: {},
      dataSource1: [],
      dataSource2: [],
      ipagination1: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: function showTotal(total, range) {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      ipagination2: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: function showTotal(total, range) {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      isorter1: {
        column: 'createTime',
        order: 'desc'
      },
      isorter2: {
        column: 'createTime',
        order: 'desc'
      },
      filters1: {},
      filters2: {},
      loading1: false,
      loading2: false,
      selectedRowKeys1: [],
      selectedRowKeys2: [],
      selectionRows1: [],
      selectionRows2: [],
      columns: [{
        title: '角色编码',
        align: 'center',
        dataIndex: 'roleCode'
      }, {
        title: '角色名称',
        align: 'center',
        dataIndex: 'roleName'
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        scopedSlots: {
          customRender: 'action'
        }
      }],
      columns2: [{
        title: '用户账号',
        align: 'center',
        dataIndex: 'username',
        width: 120
      }, {
        title: '用户名称',
        align: 'center',
        width: 100,
        dataIndex: 'realname'
      }, {
        title: '状态',
        align: 'center',
        width: 80,
        dataIndex: 'status_dictText'
      }, {
        title: '操作',
        dataIndex: 'action',
        scopedSlots: {
          customRender: 'action'
        },
        align: 'center',
        width: 120
      }],
      url: {
        list: '/sys/role/list',
        delete: '/sys/role/delete',
        list2: '/sys/user/userRoleList',
        addUserRole: '/sys/user/addSysUserRole',
        delete2: '/sys/user/deleteUserRole',
        deleteBatch2: '/sys/user/deleteUserRoleBatch',
        exportXlsUrl: 'sys/role/exportXls',
        importExcelUrl: 'sys/role/importExcel'
      }
    };
  },
  computed: {
    importExcelUrl: function importExcelUrl() {
      return "".concat(window._CONFIG['domianURL'], "/").concat(this.url.importExcelUrl);
    },
    leftColMd: function leftColMd() {
      return this.selectedRowKeys1.length === 0 ? 24 : 12;
    },
    rightColMd: function rightColMd() {
      return this.selectedRowKeys1.length === 0 ? 0 : 12;
    }
  },
  methods: {
    onSelectChange2: function onSelectChange2(selectedRowKeys, selectionRows) {
      this.selectedRowKeys2 = selectedRowKeys;
      this.selectionRows2 = selectionRows;
    },
    onClearSelected2: function onClearSelected2() {
      this.selectedRowKeys2 = [];
      this.selectionRows2 = [];
    },
    onClearSelected1: function onClearSelected1() {
      this.selectedRowKeys1 = [];
      this.selectionRows1 = [];
    },
    onSelectChange1: function onSelectChange1(selectedRowKeys, selectionRows) {
      this.selectedRowKeys1 = selectedRowKeys;
      this.selectionRows1 = selectionRows;
      this.model1 = Object.assign({}, selectionRows[0]);
      console.log(this.model1);
      this.currentRoleId = selectedRowKeys[0];
      this.loadData2();
    },
    onClearSelected: function onClearSelected() {},
    getQueryParams2: function getQueryParams2() {
      //获取查询条件
      var sqp = {};

      if (this.superQueryParams2) {
        sqp['superQueryParams'] = encodeURI(this.superQueryParams2);
      }

      var param = Object.assign(sqp, this.queryParam2, this.isorter2, this.filters2);
      param.field = this.getQueryField2();
      param.pageNo = this.ipagination2.current;
      param.pageSize = this.ipagination2.pageSize;
      return filterObj(param);
    },
    getQueryField2: function getQueryField2() {
      //TODO 字段权限控制
      var str = 'id,';
      this.columns2.forEach(function (value) {
        str += ',' + value.dataIndex;
      });
      return str;
    },
    handleEdit2: function handleEdit2(record) {
      this.$refs.modalForm2.title = '编辑';
      this.$refs.modalForm2.roleDisabled = true;
      this.$refs.modalForm2.edit(record);
    },
    handleAdd2: function handleAdd2() {
      if (this.currentRoleId == '') {
        this.$message.error('请选择一个角色!');
      } else {
        this.$refs.modalForm2.roleDisabled = true;
        this.$refs.modalForm2.selectedRole = [this.currentRoleId];
        this.$refs.modalForm2.add();
        this.$refs.modalForm2.title = '新增';
      }
    },
    modalFormOk2: function modalFormOk2() {
      // 新增/修改 成功时，重载列表
      this.loadData2();
    },
    loadData2: function loadData2(arg) {
      var _this = this;

      if (!this.url.list2) {
        this.$message.error('请设置url.list2属性!');
        return;
      } //加载数据 若传入参数1则加载第一页的内容


      if (arg === 1) {
        this.ipagination2.current = 1;
      }

      if (this.currentRoleId === '') return;
      var params = this.getQueryParams2(); //查询条件

      params.roleId = this.currentRoleId;
      this.loading2 = true;
      getAction(this.url.list2, params).then(function (res) {
        if (res.success) {
          _this.dataSource2 = res.result.records;
          _this.ipagination2.total = res.result.total;
        }

        _this.loading2 = false;
      });
    },
    handleDelete1: function handleDelete1(id) {
      this.handleDelete(id);
      this.dataSource2 = [];
      this.currentRoleId = '';
    },
    handleDelete2: function handleDelete2(id) {
      if (!this.url.delete2) {
        this.$message.error('请设置url.delete2属性!');
        return;
      }

      var that = this;
      deleteAction(that.url.delete2, {
        roleId: this.currentRoleId,
        userId: id
      }).then(function (res) {
        if (res.success) {
          that.$notification.success({
            message: res.message
          });
          that.loadData2();
        } else {
          that.$notification.warning({
            message: res.message
          });
        }
      });
    },
    batchDel2: function batchDel2() {
      if (!this.url.deleteBatch2) {
        this.$message.error('请设置url.deleteBatch2属性!');
        return;
      }

      if (this.selectedRowKeys2.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      } else {
        var ids = '';

        for (var a = 0; a < this.selectedRowKeys2.length; a++) {
          ids += this.selectedRowKeys2[a] + ',';
        }

        var that = this;
        console.log(this.currentDeptId);
        this.$confirm({
          title: '确认删除',
          content: '是否删除选中数据?',
          onOk: function onOk() {
            deleteAction(that.url.deleteBatch2, {
              roleId: that.currentRoleId,
              userIds: ids
            }).then(function (res) {
              if (res.success) {
                that.$notification.success({
                  message: res.message
                });
                that.loadData2();
                that.onClearSelected();
              } else {
                that.$notification.warning({
                  message: res.message
                });
              }
            });
          }
        });
      }
    },
    selectOK: function selectOK(data) {
      var _this2 = this;

      var params = {};
      params.roleId = this.currentRoleId;
      params.userIdList = [];

      for (var a = 0; a < data.length; a++) {
        params.userIdList.push(data[a]);
      }

      console.log(params);
      postAction(this.url.addUserRole, params).then(function (res) {
        if (res.success) {
          _this2.loadData2();

          _this2.$notification.success({
            message: res.message
          });
        } else {
          _this2.$notification.warning({
            message: res.message
          });
        }
      });
    },
    handleAddUserRole: function handleAddUserRole() {
      if (this.currentRoleId == '') {
        this.$message.error('请选择一个角色!');
      } else {
        this.$refs.selectUserModal.visible = true;
      }
    },
    handleOpen: function handleOpen(record) {
      this.selectedRowKeys1 = [record.id];
      this.model1 = Object.assign({}, record);
      this.currentRoleId = record.id;
      this.onClearSelected2();
      this.loadData2();
    },
    handleEdit: function handleEdit(record) {
      if (this.currentRoleId == '') {
        this.$message.error('请选择一个角色!');
      } else {
        this.$refs.modalForm.edit(record);
        this.$refs.modalForm.title = '编辑';
      }
    },
    searchQuery2: function searchQuery2() {
      this.loadData2(1);
    },
    searchReset2: function searchReset2() {
      this.queryParam2 = {};
      this.loadData2(1);
    },
    handleTableChange2: function handleTableChange2(pagination, filters, sorter) {
      //分页、排序、筛选变化时触发
      //TODO 筛选
      if (Object.keys(sorter).length > 0) {
        this.isorter2.column = sorter.field;
        this.isorter2.order = 'ascend' == sorter.order ? 'asc' : 'desc';
      }

      this.ipagination2 = pagination;
      this.loadData2();
    }
  }
};